import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export function isPortalApiUrl(url: string | null): boolean {
  const apiBaseUrl = environment.apiBaseUrl.replace(/\/$/, '');
  return !!url && (url === apiBaseUrl || url.startsWith(`${apiBaseUrl}/`));
}

export function isPortalUserAccessDenied(error: unknown): error is HttpErrorResponse {
  return error instanceof HttpErrorResponse
    && error.status === 403
    && error.error?.title === 'PortalUserAccessDenied'
    && isPortalApiUrl(error.url);
}
